export const optionalClassNames = {
  hamburgerActive: 'hamburger--active',
  mobileNavActive: 'mobile-navigation--open',
};
